import { googleMetrics, popIndexMetrics, tiktokMetrics } from './metrics';
import DimensionIcon from 'components/DimensionIcon';
import DrawerHeader from 'components/DrawerHeader';
import FlavorCategoriesDrawer from './FlavorCategoriesDrawer';
import FlavorHashtagsDrawer from './FlavorHashtagsDrawer';
import FlavorPostsDrawer from './FlavorPostsDrawer';
import FlavorSearchQueriesDrawer from './FlavorSearchQueriesDrawer';
import Stack from 'components/Stack';
import { buildExportFilename } from 'utils/formatCSV';
import styled from 'styled-components';
import { useCurrentCountry, useEndDate } from 'utils/hooks';

const sourceByDataSource = {
    google: 'google',
    tiktok: 'tiktok',
    pop_index: 'pop-index',
};

const metricByDataSource = {
    google: googleMetrics[0][0],
    tiktok: tiktokMetrics[0][0],
    pop_index: popIndexMetrics[0][0],
};

const DrawerStack = styled(Stack)`
    padding: 0 1rem;
`;

function FlavorsDrawer({ country, category, dataSource, flavor, flavorName }) {
    const countryObj = useCurrentCountry();
    const source = sourceByDataSource[dataSource] || dataSource;
    const date = useEndDate(source);
    return (
        <Stack $space="1.5rem">
            <DrawerHeader
                name={flavorName}
                eyebrow={
                    <>
                        <DimensionIcon dimensionType="flavor" />
                        Flavor
                    </>
                }
            />
            <DrawerStack>
                <FlavorCategoriesDrawer
                    country={country}
                    category={category}
                    dataSource={dataSource}
                    flavor={flavor}
                    flavorName={flavorName}
                    metric={metricByDataSource[dataSource]}
                />
            </DrawerStack>
            <Stack $space="2rem" css="padding-bottom: 2rem;">
                {['google', 'pop_index'].includes(dataSource) && (
                    <DrawerStack>
                        <FlavorSearchQueriesDrawer
                            country={country}
                            category={category}
                            flavor={flavor}
                            filename={buildExportFilename({
                                entity: flavorName,
                                country: countryObj,
                                source,
                                type: 'search-query',
                                kind: 'data',
                                date,
                            })}
                        />
                    </DrawerStack>
                )}
                {['tiktok', 'pop_index'].includes(dataSource) && (
                    <DrawerStack>
                        <FlavorHashtagsDrawer
                            country={country}
                            category={category}
                            flavor={flavor}
                            filename={buildExportFilename({
                                entity: flavorName,
                                country: countryObj,
                                source,
                                type: 'hashtag',
                                kind: 'data',
                                date,
                            })}
                        />
                    </DrawerStack>
                )}
                {['tiktok', 'pop_index'].includes(dataSource) && (
                    <DrawerStack>
                        <FlavorPostsDrawer
                            country={country}
                            category={category}
                            flavor={flavor}
                            flavorName={flavorName}
                        />
                    </DrawerStack>
                )}
            </Stack>
        </Stack>
    );
}

export default FlavorsDrawer;
